import {v4 as uuidv4} from "uuid";
import {faker}  from "@faker-js/faker";
import defaultValues from "../scenarios/edu-scenarios";
import {
  PENDING_STATUS,
  REJECTED_STATUS,
  WITHDRAWN_STATUS,
} from "../../utils/app-constants.json";

const addData = (data) => {
  return {
    ID: uuidv4(),
    Description: data.Description,
    Name: data.Name,
    CreatedAt: faker.date.past(),
    State: "Pending",
    CreatedBy: 7,
    Metadata: {
      PointPerson: data.Metadata.PointPerson,
      Owner: data.Metadata.Owner,
      GroupName: data.Metadata.GroupName,
      BudgetExist: data.Metadata.BudgetExist,
      BudgetValue: data.Metadata.BudgetValue,
      MeetingScheduledOn: data.Metadata.MeetingScheduledOn,
      MeetingScheduledWith: data.Metadata.MeetingScheduledWith,
      MeetingId: data.Metadata.MeetingId,
    },
    Services: data.Services,
  };
};

export const createProjectRequest = (data) => {
  const requestData = addData(data);
  return requestData;
};

export const getProjectRequestsPending = () => {
  return defaultValues().projectRequests.filter(
    (request) => request.State === PENDING_STATUS
  );
};

export const getProjectRequestsInactive = () => {
  return defaultValues().projectRequests.filter(
    (request) =>
      request.State === REJECTED_STATUS || request.State === WITHDRAWN_STATUS
  );
};
